import '../styles/contribution.css'
import Icon10 from './Icon10.jsx'

function ContributionTitle3() {
    return (
        <div id='contribution_title_display'>
            <div id='contribution_title'>
                <div id='contribution_title_icon'>
                    
                    
                    <Icon10 />
                </div>
                <div id='contribution_title_text'>Activities</div>
            </div>
        </div>
    )
}

export default ContributionTitle3